import { startDate } from "../constants";

const msInDay = 86400000;

// Counts calendar days in Los Angeles, so the day changes at midnight Pacific
// for every player, whatever their own time zone and across daylight saving.
export const daysSinceStart = (date = new Date()) => {
  const [month, day, year] = date
    .toLocaleDateString("en-US", { timeZone: "America/Los_Angeles" })
    .split("/")
    .map(Number);
  return Math.round((Date.UTC(year, month - 1, day) - startDate) / msInDay);
};

// Time left until midnight in Los Angeles, when the day changes
export const msUntilPacificMidnight = (date = new Date()) => {
  const [hours, minutes, seconds] = date
    .toLocaleTimeString("en-US", {
      timeZone: "America/Los_Angeles",
      hourCycle: "h23",
    })
    .split(":")
    .map(Number);
  return msInDay - ((hours * 60 + minutes) * 60 + seconds) * 1000;
};
